<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="姓名："
        prop="userName">
        <el-input v-model="info.userName"></el-input>
      </el-form-item>
      <el-form-item
        label="手机号："
        prop="mobilePhone">
        <el-input
          v-model="info.mobilePhone"
          type="tel"
          :maxlength="11"></el-input>
      </el-form-item>
      <el-form-item
        label="身份证："
        prop="idCertNo">
        <el-input
          v-model="info.idCertNo"
          :maxlength="18"></el-input>
      </el-form-item>
      <el-form-item
        label="核对数量："
        prop="luxuryIdentificationTimes">
        <el-input-number
          v-model="info.luxuryIdentificationTimes"
          :precision="0"
          :min="0"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'EditUserModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        userId: null,
        userName: '',
        mobilePhone: '',
        idCertNo: '',
        luxuryIdentificationTimes: 0
      },
      rules: {
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 30, message: '姓名长度最多 30 个字符', trigger: 'blur' }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        idCertNo: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' }
        ],
        luxuryIdentificationTimes: [
          { required: true, message: '请输入核对数量', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const userId = this.info.userId
      return (userId ? '编辑' : '新增') + '人员'
    },
    serviceProvinceCode() {
      return this.info.area[0] || null
    },
    serviceCityCode() {
      return this.info.area[1] || null
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        userId: null,
        userName: '',
        mobilePhone: '',
        idCertNo: '',
        luxuryIdentificationTimes: 0
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.userId
            ? 'updateuser'
            : 'adduser'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.$message.success('保存成功')
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
